const rankingItems = [
  { rank: 1, title: '久久视频 · 最新院线大片合集', tag: '热播', views: '128.6万' },
  { rank: 2, title: '小蓝视频 · 高分悬疑剧推荐', tag: '新上', views: '96.3万' },
  { rank: 3, title: '豆花视频 · 经典港片回顾专题', tag: '经典', views: '87.1万' },
  { rank: 4, title: '久久视频 · 日漫新番连载更新', tag: '连载', views: '74.5万' },
  { rank: 5, title: '小蓝视频 · 热门综艺精选合集', tag: '热门', views: '68.2万' },
  { rank: 6, title: '豆花视频 · 高分韩剧全集放送', tag: '推荐', views: '59.8万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热度榜单</h2>
            <p className="text-sm md:text-base text-foreground-600">
              久久视频、小蓝视频、豆花视频实时热度排行，热门内容一目了然
            </p>
          </div>
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer no-underline ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-accent-500 text-background-50' :
                  item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-200 text-foreground-700'
                }`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <span className="text-sm font-medium text-foreground-900 line-clamp-1">{item.title}</span>
                </div>
                <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-600 whitespace-nowrap flex-shrink-0 hidden sm:block">{item.views}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}